export default "__VITE_ASSET__6a404fa4__"